import { addLocaleToUrl } from '@utils/url';
import {
  ABSOLUTE_LINK_PATTERN,
  LOCALE_PREFIX_PATTERN,
} from '@utils/breadcrumbs/withLocalePrefix';

/**
 * Prefixes a hand-authored Prismic CTA url with the current locale segment.
 *
 * CTA urls are plain strings, so absolute/external links must be left untouched,
 * and a url whose path already carries a locale segment (e.g. "/en" or
 * "/en?ref=hero") must not be re-prefixed — addLocaleToUrl's own "/en/"/"/fr/"
 * check misses those forms since it doesn't isolate the path from the
 * query/hash.
 *
 * Unlike `withLocalePrefix` (breadcrumbs), this preserves the query string, the
 * hash and any trailing slash, because the authored url is the destination
 * verbatim rather than a path we rebuild.
 */
export const localizeHref = (url: string, locale: string) => {
  if (ABSOLUTE_LINK_PATTERN.test(url)) return url;
  const [path] = url.split(/[?#]/);
  return LOCALE_PREFIX_PATTERN.test(path) ? url : addLocaleToUrl(url, locale);
};
